import React from 'react'
import { Link } from 'react-router-dom'

export default function itemCarousel(props) {
  return (
      <>
      

              <div className="container">
                  <div className="row">
                      <div className="col-md-4">
                          <div className='img-box'>
                              { props.imgBox}
                          </div>
                      </div>
                      <div className="col-md-8">
                          <div className="detail-box">
                              <h1 className="typewriter" >{props.head1} <br /> <span>{props.head2}</span></h1>
                              <p>{props.parag}

                              </p>
                              <div>
                                  <Link to="/medici">
                                      Buy Now
                                  </Link>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          
      </>
  )
}
